const palette = {
  mode: 'light',
  primary: {
    light: '#5C87FF',
    main: '#2961FD',
    dark: '#1C43B1',
    contrastText: '#fff',
  },
  secondary: {
    light: '#E0E0E0',
    main: '#E0E0E0',
    dark: '#BDBDBD',
    contrastText: '#000',
  },
  text: {
    primary: '#000',
    secondary: '#1F1F1F',
  },
  background: {
    default: '#fff',
    paper: '#fff',
  },
  neutral: '#fff',
};

export default palette;
